import React from 'react';
import { Box, Button } from '@material-ui/core';
import { useCourierLogic } from '../../components/organisms/Couriers/useCourierLogic';
import Spin from '../../components/atoms/Spin/Spin';
import { CourierInfo } from '../../components/molecules/CourierInfo';
import { CourierRegType } from '../../api/couriers';
import CourierEditDialog from '../../components/organisms/CourierEditDialog/CourierEditDialog';

const FreelanceCourierEdit = () => {
    const {
        loading,
        handleBack,
        photos,
        request,
        classes,
        load,
        courierFormOpen,
        setCourierFormOpen,
        handleCloseCourierForm,
    } = useCourierLogic(true);

    const user = request?.courier?.user;
    const courier = request?.courier;

    return (
        <Box className={classes.root}>
            <Button onClick={handleBack}>Назад</Button>

            {loading && <Spin variant="inline" />}
            {!loading && (
                <Box marginTop={3} marginLeft={1}>
                    <CourierInfo
                        type={CourierRegType.Activation}
                        user={user}
                        courier={courier}
                        photos={photos}
                        handleEdit={() => {
                            setCourierFormOpen(true);
                        }}
                    />
                </Box>
            )}
            {courierFormOpen && (
                <CourierEditDialog
                    courier={courier}
                    open={courierFormOpen}
                    load={load}
                    onClose={handleCloseCourierForm}
                />
            )}
        </Box>
    );
};

export default FreelanceCourierEdit;
